module.exports = __webpack_public_path__ + "img/arconnect.70303b43.png";